/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandBackbone = createReactComponent("brand-backbone", "IconBrandBackbone", [
  ["path", { d: "M5 20l14 -8l-14 -8z", key: "svg-0" }],
  ["path", { d: "M19 20l-14 -8l14 -8z", key: "svg-1" }]
]);

export { IconBrandBackbone as default };
//# sourceMappingURL=IconBrandBackbone.js.map
